import { observer } from "mobx-react-lite";
import m from 'skin/store/mb'
import styles from './style.module.css'
import Icon from "../icon";
import { useEffect, useRef } from "react";

function Layout({ id, title, children, onSubmit }) {
	const mb = m.isMobile;
	const cls = s => [styles[s], styles[`${s}-${mb ? 'mb' : 'pc'}`]].join(' ');
	const ref = useRef();
	useEffect(() => {
		if (!onSubmit) return;
		const e = ref.current;
		const fn = ev => {
			if (ev.code !== 'Enter') return;
			onSubmit();
		}
		e.addEventListener('keydown', fn);
		return () => e.removeEventListener('keydown', fn);
	}, [onSubmit]);
	return <div className={cls('background')} ref={ref}>
		<div id={id} className={cls('container')}>
			<header>
				<Icon name='userId' className={styles.icon} size='48px' />
				<h1 className={styles.title}>{title}</h1>
			</header>
			{children}
		</div>
	</div>
}

export default observer(Layout);

// Раздел где лежат все блоки с полями
export const Body = observer(({ children }) => {
	const mb = m.isMobile;
	return <form className={mb ? styles.mb : styles.pc}>
		{children}
	</form>;
});

// Кнопки управления формой
export const Control = observer(({ center, children }) => {
	const mb = m.isMobile;
	const style = { justifyContent: center ? 'center' : 'space-between' };
	return <div className={mb ? styles['control-mb'] : styles.control} style={style}>
		{children}
	</div>
});

// Блок с полями
export function Item({ children }) {
	return <div className={styles.block}>
		{children}
	</div>
};

// Подвал формы
export function Footer({ children }) {
	return <footer>
		<hr />
		<div className={styles.content}>
			{children}
		</div>
	</footer>
}